import {
  ApiPath,
  konfigurasiHonorJabatanSchema,
  type CreateKonfigurasiHonorJabatanRequest,
  type UpdateKonfigurasiHonorJabatanRequest,
} from '@app/shared';
import { apiGet, apiPost, apiPatch, apiDelete, apiList } from '../../lib/api';

export async function getKonfigurasiHonorJabatanList(params?: {
  page?: number;
  limit?: number;
  search?: string;
  jabatan_id?: number;
  sort_by?: string;
  sort_dir?: 'asc' | 'desc';
}) {
  return apiList(ApiPath.SYSTEM.KONFIGURASI_HONOR_JABATAN, konfigurasiHonorJabatanSchema, params);
}

export async function getKonfigurasiHonorJabatan(id: number) {
  return apiGet(`${ApiPath.SYSTEM.KONFIGURASI_HONOR_JABATAN}/${id}`, konfigurasiHonorJabatanSchema);
}

export async function createKonfigurasiHonorJabatan(body: CreateKonfigurasiHonorJabatanRequest) {
  return apiPost(ApiPath.SYSTEM.KONFIGURASI_HONOR_JABATAN, body, konfigurasiHonorJabatanSchema);
}

export async function updateKonfigurasiHonorJabatan(
  id: number,
  body: UpdateKonfigurasiHonorJabatanRequest,
) {
  return apiPatch(
    `${ApiPath.SYSTEM.KONFIGURASI_HONOR_JABATAN}/${id}`,
    body,
    konfigurasiHonorJabatanSchema,
  );
}

export async function deleteKonfigurasiHonorJabatan(id: number) {
  return apiDelete(`${ApiPath.SYSTEM.KONFIGURASI_HONOR_JABATAN}/${id}`);
}
